import React from 'react';
import './NavigationControls.css';

interface NavigationControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  hasPrevious: boolean;
  hasNext: boolean;
  currentSectionTitle?: string;
  previousSectionTitle?: string;
  nextSectionTitle?: string;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  currentSectionTitle,
  previousSectionTitle,
  nextSectionTitle
}) => {
  return (
    <div className="navigation-controls">
      <button 
        className={`nav-button nav-previous ${!hasPrevious ? 'disabled' : ''}`}
        onClick={onPrevious}
        disabled={!hasPrevious}
        title={previousSectionTitle ? `Previous: ${previousSectionTitle}` : 'No previous section'}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M10 3L6 8L10 13" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="nav-text">
          <span className="nav-label">Previous</span>
          {previousSectionTitle && (
            <span className="nav-title">{previousSectionTitle}</span>
          )}
        </span>
      </button>

      <div className="nav-current">
        <span className="nav-current-label">Current Section</span>
        <span className="nav-current-title">{currentSectionTitle}</span>
      </div>

      <button 
        className={`nav-button nav-next ${!hasNext ? 'disabled' : ''}`}
        onClick={onNext}
        disabled={!hasNext}
        title={nextSectionTitle ? `Next: ${nextSectionTitle}` : 'No next section'}
      >
        <span className="nav-text">
          <span className="nav-label">Next</span>
          {nextSectionTitle && (
            <span className="nav-title">{nextSectionTitle}</span>
          )}
        </span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M6 3L10 8L6 13" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
};

export default NavigationControls;
